import React, { useState } from "react";
import Layout from "../components/layouts/Layout";

const TechnologyDemoPage = () => {
  const [selectedDemo, setSelectedDemo] = useState('bim');

  const demos = [
    {
      id: 'bim',
      title: 'BIM生成システム',
      subtitle: '2D図面から3DモデルへのAI自動変換',
      description: '従来手動で数日かかっていた建築図面の3Dモデル化を、AIによって15分で完了。設計変更の影響分析やコスト算出まで自動化します。',
      videoUrl: '/videos/bim-demo.mp4',
      thumbnail: '/img/bim-demo-thumb.jpg',
      features: [
        '2D図面の自動解析',
        '3Dモデル自動生成',
        '材料コスト自動算出',
        'リアルタイム設計変更反映'
      ],
      metrics: {
        '処理時間': '15分（従来: 3-5日）',
        '精度': '寸法誤差 ±2%以内',
        '対応形式': 'DWG, PDF, 画像',
        '出力形式': 'IFC, Revit, SketchUp'
      },
      useCases: [
        '新築住宅の設計検討',
        'リノベーション計画',
        '工場レイアウト最適化',
        '商業施設の空間設計'
      ]
    },
    {
      id: 'qrc',
      title: 'QRC時系列予測',
      subtitle: '量子リザバコンピューティングによる高速学習',
      description: '金融市場データや気象データなど、複雑な時系列パターンをリアルタイムで予測。従来の機械学習手法と比較して10倍以上の高速学習を実現。',
      videoUrl: '/videos/qrc-demo.mp4',
      thumbnail: '/img/qrc-demo-thumb.jpg',
      features: [
        '量子もつれを活用した並列処理',
        'ノイズ耐性による高精度予測',
        'リアルタイム学習更新',
        '複雑な非線形パターン認識'
      ],
      metrics: {
        '学習速度': '従来比 10-50倍高速',
        '予測精度': '95%以上',
        '量子ビット': '50-100 qubits',
        '処理データ': '時系列、音声、画像'
      },
      useCases: [
        '株価・為替予測',
        '気象データ解析',
        '製造業の品質予測',
        'エネルギー需要予測'
      ]
    },
    {
      id: 'hamster',
      title: 'Hamster言語モデル',
      subtitle: 'ドメイン特化型AIアシスタント',
      description: '特定業界に特化したカスタム言語モデル。技術文書の自動生成、専門用語の翻訳、コードレビューなど、専門性の高いタスクを高精度で実行。',
      videoUrl: '/videos/hamster-demo.mp4',
      thumbnail: '/img/hamster-demo-thumb.jpg',
      features: [
        'ドメイン特化アーキテクチャ',
        '多言語対応（日英中韓）',
        'プライバシー保護設計',
        '効率的ファインチューニング'
      ],
      metrics: {
        'パラメータ数': '7B - 70B',
        'コンテキスト長': '最大 128K tokens',
        '推論速度': '100 tokens/sec',
        'ファインチューニング': '数時間で完了'
      },
      useCases: [
        '技術文書の自動生成',
        '契約書類の解析',
        'コード生成・レビュー',
        '多言語技術翻訳'
      ]
    }
  ];

  const currentDemo = demos.find(demo => demo.id === selectedDemo);

  return (
    <Layout 
      title="技術デモ" 
      subtitle="最先端技術の実際の動作をご体験いただけます。ライブデモとサンプル動画で技術の真価をご確認ください。"
    >
      {/* デモ選択 */}
      <section style={{ padding: '60px 0 40px', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                <h3 style={{ color: '#f1f5f9', marginBottom: '20px' }}>デモを選択</h3>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px' }}>
                  {demos.map((demo) => (
                    <button
                      key={demo.id}
                      onClick={() => setSelectedDemo(demo.id)}
                      style={{
                        padding: '12px 24px',
                        borderRadius: '8px',
                        border: '1px solid rgba(59, 130, 246, 0.3)',
                        background: selectedDemo === demo.id ? '#3b82f6' : 'transparent',
                        color: selectedDemo === demo.id ? 'white' : '#cbd5e1',
                        cursor: 'pointer',
                        transition: 'all 0.3s',
                        fontSize: '16px',
                        fontWeight: '500'
                      }}
                    >
                      {demo.title}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* メインデモ表示 */}
      <section style={{ padding: '60px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div style={{ 
                background: 'rgba(30, 41, 59, 0.8)',
                border: '1px solid rgba(59, 130, 246, 0.2)',
                borderRadius: '16px',
                padding: '50px',
                marginBottom: '50px'
              }}>
                {/* デモヘッダー */}
                <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                  <h2 style={{ color: '#3b82f6', fontSize: '36px', fontWeight: '700', marginBottom: '10px' }}>
                    {currentDemo.title}
                  </h2>
                  <h3 style={{ color: '#94a3b8', fontSize: '18px', fontWeight: '400', marginBottom: '20px' }}>
                    {currentDemo.subtitle}
                  </h3>
                  <p style={{ color: '#cbd5e1', fontSize: '18px', maxWidth: '800px', margin: '0 auto' }}>
                    {currentDemo.description}
                  </p>
                </div>

                {/* 動画セクション */}
                <div className="row">
                  <div className="col-md-8">
                    <div style={{ 
                      background: '#000',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      position: 'relative',
                      aspectRatio: '16/9'
                    }}>
                      <video 
                        style={{ 
                          width: '100%', 
                          objectFit: 'cover'
                        }}
                        controls
                        poster={currentDemo.thumbnail}
                      >
                        <source src={currentDemo.videoUrl} type="video/mp4" />
                        お使いのブラウザは動画タグをサポートしていません。
                      </video>
                      
                      {/* 動画が読み込めない場合のフォールバック */}
                      <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        textAlign: 'center',
                        color: '#94a3b8',
                        fontSize: '16px',
                        display: 'none'
                      }}>
                        <div style={{ fontSize: '48px', marginBottom: '20px' }}>🎥</div>
                        <p>デモ動画を準備中です</p>
                        <button 
                          className="btn btn-custom"
                          onClick={() => window.open('/contact/demo', '_blank')}
                        >
                          ライブデモを申し込む
                        </button>
                      </div>
                    </div>

                    {/* 動画説明 */}
                    <div style={{ marginTop: '20px' }}>
                      <h4 style={{ color: '#f1f5f9', marginBottom: '15px' }}>デモのポイント</h4>
                      <ul style={{ color: '#cbd5e1', lineHeight: '1.6' }}>
                        {currentDemo.id === 'bim' && (
                          <>
                            <li>0:00-0:30 - 2D図面のアップロードと自動解析</li>
                            <li>0:30-2:00 - AI による3Dモデル生成プロセス</li>
                            <li>2:00-3:00 - 材料コストの自動算出</li>
                            <li>3:00-4:00 - 設計変更と即座の反映</li>
                          </>
                        )}
                        {currentDemo.id === 'qrc' && (
                          <>
                            <li>0:00-1:00 - 量子リザバの初期化と学習開始</li>
                            <li>1:00-2:30 - リアルタイム時系列予測</li>
                            <li>2:30-3:30 - 従来手法との精度比較</li>
                            <li>3:30-4:00 - 複雑パターンの認識能力</li>
                          </>
                        )}
                        {currentDemo.id === 'hamster' && (
                          <>
                            <li>0:00-1:00 - 技術文書の自動生成</li>
                            <li>1:00-2:00 - 多言語翻訳の精度</li>
                            <li>2:00-3:00 - コード生成とレビュー</li>
                            <li>3:00-4:00 - ドメイン特化の利点</li>
                          </>
                        )}
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-4">
                    {/* 主要機能 */}
                    <div style={{ marginBottom: '30px' }}>
                      <h4 style={{ color: '#f1f5f9', marginBottom: '20px' }}>主要機能</h4>
                      <ul style={{ listStyle: 'none', padding: 0 }}>
                        {currentDemo.features.map((feature, idx) => (
                          <li key={idx} style={{ 
                            color: '#cbd5e1', 
                            marginBottom: '12px',
                            paddingLeft: '20px',
                            position: 'relative'
                          }}>
                            <span style={{ 
                              position: 'absolute',
                              left: 0,
                              color: '#3b82f6',
                              fontWeight: 'bold'
                            }}>
                              ✓
                            </span>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* 技術仕様 */}
                    <div style={{ marginBottom: '30px' }}>
                      <h4 style={{ color: '#f1f5f9', marginBottom: '20px' }}>技術仕様</h4>
                      <div>
                        {Object.entries(currentDemo.metrics).map(([key, value], idx) => (
                          <div key={idx} style={{ 
                            background: 'rgba(59, 130, 246, 0.1)',
                            padding: '12px 16px',
                            borderRadius: '8px',
                            marginBottom: '10px'
                          }}>
                            <div style={{ color: '#3b82f6', fontSize: '14px', fontWeight: '600' }}>
                              {key}
                            </div>
                            <div style={{ color: '#cbd5e1', fontSize: '13px' }}>
                              {value}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* アクションボタン */}
                    <div>
                      <button 
                        className="btn btn-custom"
                        style={{ width: '100%', marginBottom: '15px' }}
                        onClick={() => window.open(`/contact/demo?tech=${currentDemo.id}`, '_blank')}
                      >
                        ライブデモを申し込む
                      </button>
                      <button 
                        className="btn btn-outline"
                        style={{ 
                          width: '100%',
                          border: '1px solid rgba(59, 130, 246, 0.5)',
                          color: '#3b82f6',
                          background: 'transparent'
                        }}
                        onClick={() => window.open(`/resources/technical-docs?tech=${currentDemo.id}`, '_blank')}
                      >
                        技術資料をダウンロード
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* 応用事例 */}
              <div style={{ 
                background: 'rgba(30, 41, 59, 0.8)',
                border: '1px solid rgba(59, 130, 246, 0.2)',
                borderRadius: '12px',
                padding: '40px'
              }}>
                <h3 style={{ color: '#f1f5f9', textAlign: 'center', marginBottom: '30px' }}>
                  実際の応用事例
                </h3>
                <div className="row">
                  {currentDemo.useCases.map((useCase, idx) => (
                    <div key={idx} className="col-md-3" style={{ marginBottom: '20px' }}>
                      <div style={{ 
                        background: 'rgba(16, 185, 129, 0.1)',
                        padding: '20px',
                        borderRadius: '8px',
                        textAlign: 'center'
                      }}>
                        <div style={{ color: '#10b981', fontSize: '24px', marginBottom: '10px' }}>
                          {idx === 0 && 'Office'}
                          {idx === 1 && 'Tech'}
                          {idx === 2 && 'Factory'}
                          {idx === 3 && 'Store'}
                        </div>
                        <div style={{ color: '#cbd5e1', fontSize: '14px' }}>
                          {useCase}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* インタラクティブデモセクション */}
      <section style={{ padding: '80px 0', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12" style={{ textAlign: 'center' }}>
              <h2 style={{ color: '#f1f5f9', marginBottom: '30px', fontSize: '32px', fontWeight: '700' }}>
                インタラクティブデモを体験
              </h2>
              <p style={{ color: '#cbd5e1', marginBottom: '40px', fontSize: '18px' }}>
                実際のデータを使ってリアルタイムで技術を体験していただけます
              </p>
              
              <div className="row">
                <div className="col-md-4" style={{ marginBottom: '30px' }}>
                  <div style={{ 
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    padding: '30px'
                  }}>
                    <div style={{ fontSize: '48px', marginBottom: '20px' }}>BIM</div>
                    <h4 style={{ color: '#3b82f6', marginBottom: '15px' }}>BIM生成体験</h4>
                    <p style={{ color: '#cbd5e1', marginBottom: '20px', fontSize: '14px' }}>
                      サンプル図面をアップロードして3Dモデル生成を体験
                    </p>
                    <button 
                      className="btn btn-custom"
                      onClick={() => window.open('/demo/bim-interactive', '_blank')}
                    >
                      体験デモを開始
                    </button>
                  </div>
                </div>
                
                <div className="col-md-4" style={{ marginBottom: '30px' }}>
                  <div style={{ 
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    padding: '30px'
                  }}>
                    <div style={{ fontSize: '48px', marginBottom: '20px' }}>QRC</div>
                    <h4 style={{ color: '#3b82f6', marginBottom: '15px' }}>QRC予測体験</h4>
                    <p style={{ color: '#cbd5e1', marginBottom: '20px', fontSize: '14px' }}>
                      リアルタイムデータで量子予測アルゴリズムを体験
                    </p>
                    <button 
                      className="btn btn-custom"
                      onClick={() => window.open('/demo/qrc-interactive', '_blank')}
                    >
                      体験デモを開始
                    </button>
                  </div>
                </div>
                
                <div className="col-md-4" style={{ marginBottom: '30px' }}>
                  <div style={{ 
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    padding: '30px'
                  }}>
                    <div style={{ fontSize: '48px', marginBottom: '20px' }}>AI</div>
                    <h4 style={{ color: '#3b82f6', marginBottom: '15px' }}>Hamster対話体験</h4>
                    <p style={{ color: '#cbd5e1', marginBottom: '20px', fontSize: '14px' }}>
                      専門特化AIとのリアルタイム対話を体験
                    </p>
                    <button 
                      className="btn btn-custom"
                      onClick={() => window.open('/demo/hamster-interactive', '_blank')}
                    >
                      体験デモを開始
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ 
        padding: '80px 0',
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: 'white', marginBottom: '20px', fontSize: '32px' }}>
                カスタムデモのご相談
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '30px', fontSize: '18px' }}>
                お客様の具体的なデータや課題に合わせた<br />
                カスタムデモも承ります
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
                <a href="/contact/demo" className="btn btn-custom btn-lg" style={{ 
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: '2px solid white',
                  color: 'white'
                }}>
                  カスタムデモを申し込む
                </a>
                <a href="/case-studies" className="btn btn-custom btn-lg" style={{ 
                  background: 'white',
                  color: '#1e40af',
                  border: '2px solid white'
                }}>
                  導入事例を見る
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TechnologyDemoPage; 